import { GameConstants } from "../constants";
import type { GunDefinition } from "../definitions/items/guns";
import { DefinitionType } from "./objectDefinitions";

/*
    A gun picked up while the hand holds no gun (the fists, a melee weapon or a grenade) and both gun slots are full (a
    tester's, passed on by the owner on 23 October 2026: "fix these tester complaints please": "If you have fists or melee
    weapon selected, and u try picking up a gun, it doesn't pick up obviously cause it cannot swap melee for a gun, it
    could be so that it just changes with the 1st weapon slot so at least something happens, rather than a player
    pressing f and thinking something isn't working"): it takes the first gun slot's place, its gun dropped as when a
    gun in hand is swapped. The second slot's instead when the first is locked or holds this same gun.

    The server (`Loot.canInteract`, `Loot.interact`) and the page's pickup prompt (its `Loot.canInteract`) ask the same.
*/

/** the gun slots: the slots a gun goes in (the first two) */
export const GUN_SLOTS: readonly number[] = GameConstants.player.inventorySlotTypings
    .map((type, slot) => type === DefinitionType.Gun ? slot : -1)
    .filter((slot) => slot >= 0);

/**
 * The gun slot whose gun `gun` takes the place of when picked up with no gun in hand and no gun slot free, or -1: a gun
 * in hand (it's swapped for that one, as before), a gun slot free (it goes there), or no slot it may take (both locked,
 * or holding this same gun)
 * @param weapons what each weapon slot holds (`undefined` empty)
 * @param activeWeaponIndex the slot in hand
 * @param isLocked whether a slot is locked (the game's mode can lock one)
 */
export function gunSwapSlot(
    weapons: ReadonlyArray<{ readonly definition: { readonly defType: DefinitionType } } | undefined>,
    activeWeaponIndex: number,
    isLocked: (slot: number) => boolean,
    gun: GunDefinition
): number {
    if (GameConstants.player.inventorySlotTypings[activeWeaponIndex] === DefinitionType.Gun) return -1;
    if (GUN_SLOTS.some((slot) => weapons[slot] === undefined && !isLocked(slot))) return -1;
    for (const slot of GUN_SLOTS) {
        const held = weapons[slot];
        if (held !== undefined && !isLocked(slot) && held.definition.defType === DefinitionType.Gun && held.definition !== gun) return slot;
    }
    return -1;
}
